import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { masterServices } from 'src/app/module/master/services/ems-services.service';
import { ordersService } from '../../services/orders.service';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
  selector: 'app-exchange-component',
  templateUrl: './exchange-component.component.html',
  styleUrls: ['./exchange-component.component.css']
})
export class ExchangeComponentComponent {
truckDetails: any;
  tyreList: any;
  batteryList: any;
  componantList: any;
outgoingSerialNumber: any;
incomingSerialNumber: any;
  selectedComponentIncoming: any;
  selectedComponentOutgoing:any
  componentType: any;
  associationDate:any;
  associationStatus:any
associationkm:any
exchangeDate:any;
runkm:any;
exchangeAssociationkm:any;
  outgoingAssociationType: any;
  incomingAssociationType:any;
  truckTranscations:any
  componentListOutgoing:any[]=[];
  statusList = [
    { value: 'Idle', label: 'Idle' },
    { value: 'Retired', label: 'Retired' },
    { value: 'Damaged', label: 'Damaged' },
    { value: 'InRepair', label: 'InRepair' },
    { value: 'Lost', label: 'Lost' },
    // { value: 'Parked', label: 'Parked' },
    // { value: 'Broken', label: 'Broken' },
    { value: 'Expired', label: 'Expired' }
    ]
deAssociationStatus:any;
 maxDate: Date = new Date();
  constructor(
    public dialogRef: DynamicDialogRef,
        private datePipe: DatePipe,
        public data: DynamicDialogConfig,
        private masterServices: masterServices,
        private ordersService: ordersService,
        private messageService: MessageService,
        private sharedService: SharedService
  ){
    console.log("data",data)

    this.truckDetails = data?.data?.data
    console.log(this.truckDetails)
    this.getTruckBuildById(this.truckDetails?.id)
  }


  onTypeChange(type:any){
    console.log(type)
    this.componentType = type

    const postData = [
      {
        key: 'COMPONENT_TYPE_IN',
        value: this.componentType,
      },
      {
        key: 'STATUS_IN',
        value: 'new,idle',
      }
    ];
    this.masterServices.getComponentInfo(postData, 0, 1000, 'id', 'DESC').subscribe((data: any) => {
            this.componantList = data?.responseObject?.content;
          this.incomingSerialNumber = ''
          this.outgoingSerialNumber = ''
          if(this.componentType == 'tyre'){
            this.tyreList = data?.responseObject?.content;
          }else if(this.componentType == 'battery'){
            this.batteryList = data?.responseObject?.content;
          }
        },(err) => {
          this.componantList = []
          this.batteryList = [];
          this.tyreList = [];
        },
      );
  }

  onserialChange(event:any){
    console.log(event)
    const componant = this.componentListOutgoing.find((s: any) => s.id === event);
    console.log(componant,'componantcomponant')
    this.selectedComponentOutgoing = componant
    this.associationkm = this.selectedComponentOutgoing?.totalKmTravelled ?? ''
    this.runkm = this.selectedComponentOutgoing?.totalKmTravelled -this.selectedComponentOutgoing?.initialKmTravelled
    this.associationDate = this.sharedService.parseDateStringToDate(this.selectedComponentOutgoing?.createdAt)
  }
  onserialChangeIncoming(event:any){
    console.log(event)
    const componant = this.componantList.find((s: any) => s.id === event);
    console.log(componant,'componantcomponant')
    this.selectedComponentIncoming = componant
  }
  onChangecomponentType(associationType:any){
    console.log(associationType)
      this.outgoingAssociationType = associationType
      if(this.truckTranscations && this.truckTranscations.length>0){
        this.componentListOutgoing = this.truckTranscations.filter((el:any)=>{
          if(associationType === 'TRUCK'){
            if(el.associationType === 'TRUCK'){
              return el
            }
          }
          if(associationType === 'TRAILER'){
            if(el.associationType === 'TRAILER'){
              return el
            }
          }
        })
      }
  }
  onChangecomponentTypeIncoming(associationType:any){
    console.log(associationType)
      this.incomingAssociationType = associationType
  }
  addComponent(){
  
    let associatedTyres = this.truckDetails?.associatedTyres || 0;
    let associatedTrailerTyres = this.truckDetails?.associatedTrailerTyres || 0;
    let associatedBatteries = this.truckDetails?.associatedBatteries || 0;

    // if (this.selectedComponentIncoming?.componentType === "Tyre" 
    //   && this.incomingAssociationType === "TRUCK"
    //   ) {
    //   associatedTyres = associatedTyres + 1;
    //     if ((this.truckDetails?.tyreCapacity ?? 0) <= associatedTyres) {
    //       this.messageService.add({
    //         severity: 'warn',
    //         summary: 'Limit reached',
    //        detail: `Maximum ${this.truckDetails?.tyreCapacity} Truck tyres allowed`
    //       });
    //       return;
    //     }
    //     // return ;
    // }
    // if (this.selectedComponentIncoming?.componentType === "Tyre" &&
    //     this.incomingAssociationType === "TRAILER") {
    //   associatedTrailerTyres = associatedTrailerTyres + 1;
    //   if((this.truckDetails?.trailerTyreCapacity ?? 0) <= associatedTrailerTyres){
    //       this.messageService.add({
    //         severity: 'warn',
    //         summary: 'Limit reached',
    //         detail: `Maximum ${this.truckDetails?.tyreCapacity} Trailer tyres allowed`
    //       });
    //       return
    //     }
    //   //   return false;
    // }
    // if (this.selectedComponentIncoming?.componentType === "Battery") {
    //   associatedBatteries = associatedBatteries + 1;
    //   if((this.truckDetails?.associatedBatteries?? 0) <= associatedBatteries){
    //       this.messageService.add({
    //         severity: 'warn',
    //         summary: 'Limit reached',
    //         detail: `Maximum ${this.truckDetails?.associatedBatteries} Battery allowed`
    //       });
    //       return
    //     }
    //   //   return false;
    // }

    const payload = {
      id: this.truckDetails?.id,
      associatedTyres: associatedTyres,
      associatedTrailerTyres: associatedTrailerTyres,
      associatedBatteries: associatedBatteries,
      'initialKmTravelled':this.exchangeAssociationkm,
      commponentAssociation:
          [
            {
            associationType: this.incomingAssociationType,
            componentType:this.selectedComponentIncoming?.componentType,
            oldComponentId: this.selectedComponentOutgoing?.id,
            "newComponentId": this.selectedComponentIncoming?.id,
            "newComponentStatus": 'InUse',
            "oldComponentStatus":this.deAssociationStatus,
            newComponentFromDate:this.associationDate ? this.datePipe.transform(this.associationDate, 'dd-MM-yyyy HH:mm:ss Z')  : null,
            oldComponentToDate:this.exchangeDate ? this.datePipe.transform(this.exchangeDate, 'dd-MM-yyyy HH:mm:ss Z')  : null,
          }
      ],
    }
    console.log(payload)
    this.ordersService.getBuild(payload).subscribe((data: any) => {
      if (data) {
        console.log(data)
        this.dialogRef.close(data);
        // this._route.navigate(['/orders']);
      }
    })
  }
close(){
  this.dialogRef.close('data');
}


getTruckBuildById(id: any) {
  this.ordersService.getTruckBuildById(id).subscribe((res: any) => {
    // this.truckDetails = res?.responseObject;   
    this.truckTranscations = res?.responseObject?.component
    console.log(res);
    console.log(this.truckTranscations);

  // }

  })
}

}

